<template>
    <b-modal id="vendor_delete" ref="vendor_delete" footer-class="no-border"
             @hidden="resetForm" :title="setTitle">
        <b-row v-if="validationError" class="mb-2">
            <b-colxx md="12">
                <b-alert class="text-center" show variant="danger"
                         v-text="validationError"/>
            </b-colxx>
        </b-row>

        <span>
            You can't revert back your action if you delete this data. For further query, contact Database Manager!
        </span>

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('vendor_delete')" v-text="'Cancel'"/>

            <state-button size="sm" v-if="mode === 'vendor'" variant="danger" :click="deleteVendor">Delete</state-button>

            <state-button size="sm" v-else variant="danger" :click="deleteComment">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
    import StateButton from "../../../../components/Common/StateButton";

    export default {
        name: "VendorDeleteModal",

        components: {
            StateButton,
        },

        props: [
            'vendor', 'comment', 'mode'
        ],

        computed: {
            setTitle() {
                if (this.mode === 'vendor') {
                    return 'Delete ' + this.vendor.data.attributes.name + '?';
                } else {
                    return 'Delete comment?';
                }
            },
        },

        data() {
            return {
                validationError: null
            }
        },

        methods: {
            deleteVendor() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteVendor', this.vendor)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('deleted-vendor');

                                this.$notify('error filled', 'Success!', 'Deleted the vendor!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('vendor_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            if (error.response.data.error) {
                                this.validationError = error.response.data.error;
                            }

                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            deleteComment() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteVendorComment', this.comment)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('deleted-comment');

                                this.$notify('error filled', 'Success!', 'Deleted the comment!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('vendor_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },

            resetForm() {
                this.$emit('close');

                this.validationError = null;
            }
        },
    }
</script>

<style scoped>

</style>
